<div
  class="sticky top-0 z-10 flex min-h-[44px] flex-row flex-wrap items-center gap-2 bg-[#fafafa] pb-2"
>
  <h2 class="!m-0 !font-bold">Charts</h2>
  <div class="flex grow">
    <mat-icon
      class="icon-sm opacity-50"
      matTooltip="Charts provide a visual summary of your data. Use them to quickly spot trends, patterns, and comparisons. Interacting with a chart allows you to drill down into specific data points or categories by applying temporary filters."
    >
      info
    </mat-icon>
  </div>
  @if (store.results$ | async; as results) {
    @if (store.dynamicFilterCount$ | async) {
      <div class="text-xs opacity-50">
        {{ store.dynamicFilterCount$ | async }} temporary filters applied
      </div>
      <button
        mat-icon-button
        color="primary"
        class="icon-sm"
        matTooltip="Reset temporary filters"
        (click)="store.resetActiveFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
      </button>
    }
  }
</div>

<div class="flex flex-row flex-wrap gap-2">
  @for (section of customReport().chartSections; track section.uid) {
    @for (
      chart of section.charts;
      track chart.uid;
      let index = $index;
      let isFirst = $first;
      let isLast = $last
    ) {
      @if (chart | map: getChartDisplay$ : this | async; as display) {
        <pr-report-builder-chart
          [ngClass]="chart | map: getChartClasses : this"
          [display]="display"
          [sectionName]="section.name"
          (edit)="editChart(display.chart)"
        >
          <ng-container ngProjectAs="report-builder-chart-action">
            @if (display | map: isTable) {
              <pt-download-report
                [iconOnly]="true"
                [data]="display | map: getCSVData"
                [csvTranslator]="
                  display | map: getCSVTranslator$ : this | async
                "
              />
            }

            @if ((hasEditPermissions$ | async) && !readonly()) {
              <button
                mat-icon-button
                class="icon-sm opacity-50"
                [matMenuTriggerFor]="menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                @if (display | map: isTable) {
                  <button mat-menu-item (click)="editTable(display.chart)">
                    <mat-icon>edit</mat-icon> Edit Chart
                  </button>
                } @else {
                  <button mat-menu-item (click)="editChart(display.chart)">
                    <mat-icon>edit</mat-icon> Edit Chart
                  </button>
                }

                <mat-divider />
                <button
                  mat-menu-item
                  [disabled]="isFirst"
                  (click)="moveChartLeft(display, section.name)"
                >
                  <mat-icon>arrow_backward</mat-icon> Move Left
                </button>
                <button
                  mat-menu-item
                  [disabled]="isLast"
                  (click)="moveChartRight(display, section.name)"
                >
                  <mat-icon>arrow_forward</mat-icon> Move Right
                </button>
                <mat-divider />
                <button mat-menu-item (click)="addChart(index)">
                  <mat-icon>add</mat-icon> Add Chart Left
                </button>
                <button mat-menu-item (click)="addChart(index + 1)">
                  <mat-icon>add</mat-icon> Add Chart Right
                </button>

                <mat-divider />

                <button mat-menu-item (click)="deleteChart(display)">
                  <mat-icon color="warn">delete</mat-icon> Delete Chart
                </button>
              </mat-menu>
            }
          </ng-container>
        </pr-report-builder-chart>
      }
    }
  }

  @if ((hasEditPermissions$ | async) && !readonly()) {
    <div
      matRipple
      class="hover:border-primary-200 hover:text-primary-200 flex min-h-[200px] w-64 cursor-pointer flex-row items-center justify-center gap-1 rounded-lg border-2 border-dashed border-slate-200 font-bold opacity-50 hover:opacity-100"
      (click)="addChart()"
    >
      <mat-icon>add</mat-icon>
      <div>Add Chart</div>
    </div>
  }
</div>
